import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { ensureScenarioOrRedirect } from '@/lib/utils/planner/ensureScenarioOrRedirect';
import { setLastVisitedScenarioId } from '@/lib/utils/planner/lastVisitedScenario';
import { itemFilterUrlSearchSchema } from '@/lib/zod-schemas/itemFilterUrlSearchSchema';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

const paramsSchema = z.object({
  scenarioId: z.coerce.number().int().positive(),
});

// Declared here (the scenario parent route), not on the table/ or timeline/ leaves, so both
// inherit the same item-filter search state instead of maintaining two separate schemas.
const scenarioSearchSchema = itemFilterUrlSearchSchema.extend({
  ...itemPanelSearchSchema.shape,
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId')({
  params: paramsSchema,
  validateSearch: zodValidator(scenarioSearchSchema),
  beforeLoad: async ({ params: { loopId, scenarioId, org }, context: { queryClient } }) => {
    setLastVisitedScenarioId(loopId, scenarioId);
    await ensureScenarioOrRedirect({ loopId, scenarioId, org, queryClient });
  },
});
